import React from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAppTheme } from '../App';
import ThemeToggle from './ThemeToggle';
import logo from '../assets/logo-rounded.png';

interface GlobalTopNavBarProps {
    onDrawerToggle: () => void;
    isMobile?: boolean;
}

const GlobalTopNavBar: React.FC<GlobalTopNavBarProps> = ({ onDrawerToggle, isMobile = false }) => {
    const { isDarkMode, getThemeStyles } = useAppTheme();
    const theme = getThemeStyles();

    return (
        <AppBar
            position="static"
            color="default"
            elevation={0}
            sx={{
                width: '100%',
                minHeight: 64,
                background: isDarkMode
                    ? 'rgba(26, 26, 26, 0.95)'
                    : 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(16px)',
                boxShadow: 'none',
                borderBottom: `1px solid ${theme.borderColor}`,
                zIndex: theme => theme.zIndex.drawer + 1,
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* Only show menu button on mobile */}
                    {isMobile && (
                    <IconButton
                        edge="start"
                        aria-label="menu"
                        onClick={onDrawerToggle}
                        sx={{
                            mr: 2,
                            color: theme.textPrimary,
                            '&:hover': {
                                backgroundColor: isDarkMode
                                        ? 'rgba(255, 255, 255, 0.08)'
                                        : 'rgba(254, 106, 46, 0.08)',
                            },
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    )}
                    
                    {/* Logo and App Name */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <img
                            src={logo}
                            alt="thevisa.ai logo"
                            style={{
                                height: '32px',
                                width: 'auto',
                                objectFit: 'contain',
                                filter: isDarkMode ? 'brightness(1.1)' : 'none',
                            }}
                        />
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                color: theme.textPrimary,
                                fontSize: '1.1rem',
                            }}
                        >
                            thevisa.ai
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ThemeToggle />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default GlobalTopNavBar; 